import List from '../../components/List';
import ListItem from '../../components/ListItem';
import LoadingIndicator from '../../components/LoadingIndicator';
import PropTypes from 'prop-types';
import React from 'react';

function ProjectList({ loading, error, projects }) {

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error !== false) {
    const ErrorComponent = (
      <ListItem item="Something went wrong, please try again!" />
    );
    return <List component={ErrorComponent} isGrid={false} />;
  }

  if (projects && !loading) {
    return <List items={projects} />;
  }

  return null;
}

ProjectList.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.any,
  projects: PropTypes.any,
};

export default ProjectList;
